import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { AgGridModule, ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface IconButtonRendererParent {
	onIconClicked(deviceId: string): void;
}

interface IconRendererComponentContext {
	componentParent: IconButtonRendererParent;
}

export enum IconCellDataStates {
	Delete = 'Delete',
	Add = 'Add'
}

export interface IconCellData {
	id: string;
	state: IconCellDataStates;
}

export type IconButtonRendererComponentParamsType = ICellRendererParams<
	object,
	IconCellData,
	IconRendererComponentContext
>;

/**
 * ```sh-icon-button-renderer``` is a view component for displaying an icon button in a cell
 */
@Component({
	selector: 'sh-icon-button-renderer',
	templateUrl: './icon-button-renderer.component.html',
	styleUrls: ['./icon-button-renderer.component.scss'],
	imports: [CommonModule, AgGridModule, MatButtonModule, MatIconModule, TranslocoModule]
})
export class IconButtonRendererComponent implements ICellRendererAngularComp {
	public params!: IconButtonRendererComponentParamsType;
	public cellData?: IconCellData;
	public icon = '';
	private id = '';

	constructor(public readonly transloco: TranslocoService) {}

	public agInit(params: IconButtonRendererComponentParamsType): void {
		this.update(params);
	}

	public refresh(params: IconButtonRendererComponentParamsType): boolean {
		this.update(params);
		return true;
	}

	public onClick(): void {
		if (!this.params.data) {
			return;
		}

		this.params.context.componentParent.onIconClicked(this.id);
	}

	private update(params: IconButtonRendererComponentParamsType): void {
		this.params = params;
		this.cellData = params.value ?? undefined;
		this.id = this.cellData?.id ?? '';
		switch (this.cellData?.state) {
			case IconCellDataStates.Delete:
				this.icon = 'remove_circle_outline';
				break;
			case IconCellDataStates.Add:
				this.icon = 'add_circle';
				break;
			default:
				this.icon = '';
				break;
		}
	}
}
